// extracted by mini-css-extract-plugin
export default {"bgContainer":"HomeScreen_bgContainer__uragW","mainWhiteContainer":"HomeScreen_mainWhiteContainer__G9cW2","mainBlackContainer":"HomeScreen_mainBlackContainer__2u-Vg"};